import api from './apiService';

export async function getQuestions() {
//   const res = await api.get('/questions');
    //   return res.data;
    return Promise.resolve({
    questions: [
      { id: 1, title: 'Describe your favorite hobby', difficulty: 'Easy' },
      { id: 2, title: 'Explain the impact of AI in healthcare', difficulty: 'Medium' },
      { id: 3, title: 'Argue for/against remote work', difficulty: 'Hard' },
    ],
  });
}

export async function getQuestionById(id) {
//   const res = await api.get(`/questions/${id}`);
    //   return res.data;
    const all = [
    { id: 1, title: 'Describe your favorite hobby', difficulty: 'Easy', instructions: 'Talk about your hobby in detail.', word_limit: 100 },
    { id: 2, title: 'Explain the impact of AI in healthcare', difficulty: 'Medium', instructions: 'Provide examples of AI applications in healthcare.', word_limit: 200 },
    { id: 3, title: 'Argue for/against remote work', difficulty: 'Hard', instructions: 'Present pros and cons with evidence.', word_limit: 300 },
  ];
  const question = all.find(q => q.id === id) || null;
  return Promise.resolve({ question });
}

export async function submitDraft(questionId, text) {
//   const res = await api.post('/submissions', {
//     question_id: questionId,
//     draft_text: text,
//   });
    //   return res.data;
    const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
  return Promise.resolve({
    feedback: {
      comments: [
        'Good structure.',
        'Consider adding more specific examples.',
        'Be mindful of grammar and punctuation.',
      ],
      tokens_used: wordCount + 10,
    },
  });
}
